import useSWR from "swr";
import axios from "axios";

function useAllocationReadyProjects({ shouldFetch = true, labourerId, startDate, endDate, page, perPage }) {
  return useSWR(shouldFetch ? [`${process.env.REACT_APP_API_URL}/projects/allocation-ready`, labourerId, startDate, endDate, page, perPage] : null, async ([url, labourerId, startDate, endDate, page, perPage]) => {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (labourerId) params.append('labourerId', labourerId);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const { data: { projects, count } } = await axios.get(`${url}?${params.toString()}`);

    return { projects, count };
  });
}

export default useAllocationReadyProjects;
